import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConsistencyIssue, ConsistencyIssueViewModel } from "../issues/factory/model/consistency-issue.models";
import { IndElement } from "@shared/models/cat.model";
import { RevRule } from "@shared/models/rev.model";

@Component({
    selector: 'consistency-issues',
    templateUrl: './consistency-issues.component.html',
    styleUrls: ['./consistency-issues.component.scss'],
    standalone: false
})
export class ConsistencyIssuesComponent implements OnInit {

    @Input() consistencyIssues: ConsistencyIssue[];

    @Input() element: IndElement | RevRule;

    @Input() disableActions = false;

    @Output() viewConsistencyIssueEmitter: EventEmitter<ConsistencyIssueViewModel> = new EventEmitter();
    @Output() removeConsistencyIssueEmitter = new EventEmitter();

    @Output() markConsistencyIssueAsConsistent = new EventEmitter();

    ngOnInit(): void {}

    viewConsistencyIssue(consistencyIssue: ConsistencyIssue) {
      
      let viewModel: ConsistencyIssueViewModel = consistencyIssue.view();
      this.viewConsistencyIssueEmitter.next(viewModel);

    }

    removeConsistencyIssue(consistencyIssueToRemove: ConsistencyIssue) {

      let indexOf = this.consistencyIssues?.indexOf(consistencyIssueToRemove);
      if (indexOf != -1) {
        this.consistencyIssues.splice(indexOf, 1);
      }
      consistencyIssueToRemove.remove(this.element);
      
      this.removeConsistencyIssueEmitter.emit();
      this.element.consistencyIssuesDirty = true;
      

    }

    highlightRow(row: ConsistencyIssue): boolean {

      return row.convertible;

    }

    toggleExplanation(row: any, event: MouseEvent): void {
      event.preventDefault();
      row._isExplanationExpanded = !row._isExplanationExpanded;
    }
    
    markAsConsistent(consistencyIssue: ConsistencyIssue) {

      let indexOf = this.consistencyIssues?.indexOf(consistencyIssue);
      if (indexOf != -1) {
        this.consistencyIssues.splice(indexOf, 1);
      }
      consistencyIssue.markAsConsistent(this.element);
      this.markConsistencyIssueAsConsistent.emit();
    }

    getCategoryClass(category: string): string {
      return category
        ? `consistency-issues-category-pill--${category.trim().toLowerCase()}` : '';
    }

}